module.exports = __webpack_public_path__ + "media/images/eliminated-0cae7d7515d7b1644768cb901847d3d2.svg";